<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M20.3011 0H3.0332V28H24.9672V4.66608L20.3011 0Z" fill="#E8E8E8" />
    <path
      d="M13.1477 15.3646H8.57227V16.5527H13.1477V15.3646Z"
      fill="#D1D3D3" />
    <path d="M18.5041 13.089H8.57227V14.2771H18.5041V13.089Z" fill="#D1D3D3" />
    <path
      d="M19.4283 10.8132H8.57227V12.0013H19.4283V10.8132Z"
      fill="#D1D3D3" />
    <path
      d="M16.1644 8.53748H8.57227V9.72558H16.1644V8.53748Z"
      fill="#D1D3D3" />
    <path
      d="M19.4283 6.26184H8.57227V7.44995H19.4283V6.26184Z"
      fill="#D1D3D3" />
    <path
      d="M10.4529 25.2926H9.25573V21.8406H8.17383V20.8617H11.5318V21.8406H10.4529V25.2926Z"
      fill="#A4A9AD" />
    <path
      d="M16.1575 25.2925H14.7724L13.9087 23.9074L13.0539 25.2925H11.6992L13.1692 23.0255L11.7871 20.8615H13.1145L13.9146 22.2314L14.6845 20.8615H16.0514L14.6481 23.1194L16.1575 25.2925Z"
      fill="#A4A9AD" />
    <path
      d="M18.6092 25.2925H17.4121V21.8405H16.3301V20.8616H19.6881V21.8405H18.6091L18.6092 25.2925Z"
      fill="#A4A9AD" />
    <path
      d="M21.0232 2.33309H3.0332V0H20.3011L21.0232 2.33309Z"
      fill="#A4A9AD" />
    <path d="M20.3008 4.66608H24.9669L20.3008 0V4.66608Z" fill="#D1D3D3" />
  </svg>
</template>
